const oneDimensionalDPProblems = [
  {
   title: "House Robber",
   url: "https://leetcode.com/problems/house-robber/"
  },
  {
    title: "Climbing Stairs",
    url: "https://leetcode.com/problems/climbing-stairs/"
  },
  {
    title: "Maximum Subarray",
    url: "https://leetcode.com/problems/maximum-subarray/"
  },
  {
    title: "Coin Change",
    url: "https://leetcode.com/problems/coin-change/"
  },
  {
    title: "Decode Ways",
    url: "https://leetcode.com/problems/decode-ways/"
  }
];
export default oneDimensionalDPProblems;